/* =============================
   SnooozeCo - Featured Artifact
   ============================= */

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-desc]').forEach((container) => {

    const preview = container.querySelector('[data-preview]');
    const full    = container.querySelector('[data-full]');
    const caretPreview = container.querySelector('.artifact-desc__caret--preview');
    const caretFull    = container.querySelector('.artifact-desc__caret--full');

    if (!preview || !full) return;

    let isOpen = false;

    function expand() {
      full.style.height = full.scrollHeight + 'px';
      isOpen = true;
      container.classList.add('artifact-desc--open');

      full.addEventListener('transitionend', function _done() {
        if (isOpen) full.style.height = 'auto';
        full.removeEventListener('transitionend', _done);
      });
    }

    function collapse() {
      if (full.style.height === 'auto' || full.style.height === '') {
        full.style.height = full.scrollHeight + 'px';
      }

      full.offsetHeight;
      full.style.height = '0';
      isOpen = false;
      container.classList.remove('artifact-desc--open');
    }

    preview.addEventListener('click', () => isOpen ? collapse() : expand());
    caretPreview?.addEventListener('click', (e) => { e.stopPropagation(); expand(); });

    full.addEventListener('click', () => { if (isOpen) collapse(); });
    caretFull?.addEventListener('click', (e) => { e.stopPropagation(); collapse(); });

  });
});